import { browserTracingIntegration, init, makeBrowserOfflineTransport, makeFetchTransport } from '@sentry/browser';

const transport = makeBrowserOfflineTransport((
    options,
) => makeFetchTransport({
    ...options,
    // masking sentry_key because adblockers use it for blocking sentry
    url: options.url.replace(/sentry_key/, 'xauth'),
}));

export function initSentry(serverHostname: string, environment: string): void {
    if (!import.meta.env.VITE_SENTRY_RELEASE) {
        return;
    }

    init({
        dsn: `https://token@${serverHostname}/_report/65`,
        release: import.meta.env.VITE_SENTRY_RELEASE,
        transport,
        environment,
        integrations: [
            browserTracingIntegration(),
        ],
        tracePropagationTargets: ['localhost', new RegExp(environment)],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
